const isUrl = function (str) {
    return /^((ht|f)tps?):\/\/[\w-]+(\.[\w-]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/.test(str);
}
const getDate = function (date) {
    if(date) {
        let arr = date.split(/[-:\s]/);
        arr = arr.concat(new Array(6 - arr.length).fill(0));
        arr[1] = arr[1] && arr[1] > 0 ? arr[1] - 1 : 0;
        return new Date(...arr);
    } else {
        return null;
    }
}
const getNowTimeText = function (time) {
    let type = Object.prototype.toString.call(time);
    if(type !== '[object Date]') {
        if(type === '[object String]') {
            time = getDate(time);
        } else {
            time = new Date(time);
        }
    }
    time = time.getTime();
    let now = Date.now();
    let offset = now - time;
    let text = "";
    if(offset < 0) {
        text = '未来';
    } else if ( offset < 60 * 1000) {
        text = "刚刚"
    } else if (offset < 60 * 60 * 1000) {
        text = `${Math.floor(offset / (60 * 1000))}分钟前`;
    } else if (offset < 24 * 60 * 60 * 1000) {
        text = `${Math.floor(offset / (60 * 60 * 1000))}小时前`;
    }else if (offset < 30 * 24 * 60 * 60 * 1000) {
        text = `${Math.floor(offset / (24 * 60 * 60 * 1000))}天前`;
    } else if(offset < 365 * 24 * 60 * 60 * 1000) {
        text = `${Math.floor(offset / (30 * 24 * 60 * 60 * 1000))}个月前`;
    } else {
        text = text = `${Math.floor(offset / (365 * 24 * 60 * 60 * 1000))}年前`;
    }
    return text;
}

const getMsgTimeText = function (time) {
    let type = Object.prototype.toString.call(time);
    if(type !== '[object Date]') {
        if(type === '[object String]') {
            time = getDate(time);
        } else {
            time = new Date(time);
        }
    }
    let text = "";
    let tis = time.getTime();
    let now = new Date();
    let today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0,0);
    let tds = today.getTime();
    if(now.getTime() - tis <= 60 * 1000) {
        text = "刚刚";
    } else if(tis >= tds) {
        text = time.pattern("HH:mm");
    } else if(tis >= tds - 24 * 60 * 60 * 1000) {
        text = "昨天";
    } else if (tis >= tds - 7 * 24 * 60 * 60 * 1000) {
        text = time.pattern("EEE");
    } else {
        text = time.pattern("yyyy-MM-dd");
    }
    return text;

    // let offset = now - time;
    // return text;
}

const getQuery = function (key) {
    let query = {};
    let search = location.search.substr(1).split(/[?&]/);
    search.forEach(item => {
        let temp = item.split("=");
        if(temp.length > 1) {
            query[temp[0]] = temp[1];
        }
    });
    if(key) {
        return query[key];
    } else {
        return query;
    }
}

//获取当前时间在传入的时间段的那个位置 1之前 2之间 3之后
const getCurrentTimeRange = function (start, end) {
    start = getDate(start), end = getDate(end);
    let now = Date.now();
    if(now < start) {
        return 1;
    } else if(now <= end) {
        return 2;
    } else {
        return 3;
    }
}

const isEmpty = function (str) {
    return str === undefined || str === null || str === '' || str === false;
}
const getTimePeriod = function(startTime, endTime) {
    let res = null;
    if(startTime && endTime) {
        let start = getDate(startTime);
        let end = getDate(endTime);
        let sd = start.pattern("yyyy-MM-dd"), st = start.pattern("HH:mm");
        let ed = end.pattern("yyyy-MM-dd"), et = end.pattern( "HH:mm");
        if(sd == ed) {
            res = `${sd} ${st} - ${et}`;
        } else {
            res = `${sd} - ${ed}`;
        }
    }
    return res;
}

const overscroll = function (el) {
    el.addEventListener("touchstart", () => {
        let top = el.scrollTop, totalScroll = el.scrollHeight, currentScroll = top + el.offsetHeight;
        if(top === 0) {
            el.scrollTop = 1;
        } else if(currentScroll === totalScroll) {
            el.scrollTop = top - 1;
        }
    }, {passive: false});
    el.addEventListener("touchmove", e => {
        if(el.offsetHeight < el.scrollHeight) {
            e._isScroller = true;
        }
    }, {passive: false});
}

const setLiveState = function (live) {
    if(isEmpty(live.status)) {
        const {start_time, end_time} = live;
        if(start_time && end_time) {
            const start = getDate(start_time).getTime();
            const end = getDate(end_time).getTime();
            const now = Date.now();
            if(now >= start && now <= end) {
                live.status = 1;
                live.statusText = '直播中';
            } else if (now < start) {
                live.status = 2;
                live.statusText = '未开始';
            } else if (now > end) {
                live.status = 3;
                live.statusText = '已结束';
            }
        }
    }
}

export { isUrl, getDate, getNowTimeText, getMsgTimeText, getQuery, getCurrentTimeRange, isEmpty, getTimePeriod, overscroll, setLiveState };
